/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'avatar': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" d="M15.12 16.896a7.947 7.947 0 007.946-7.948 7.947 7.947 0 10-15.891 0 7.947 7.947 0 007.945 7.948z" _stroke="#2E48DA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M29 29c0-6.69-5.42-12.113-12.11-12.113h-3.78C6.42 16.887 1 22.309 1 29" _stroke="#2E48DA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/avatar.js